// The Wahala logo (design system assets/Logos and assets/App), never live type.
// Title screens: the keke mark above the plate lockup, as on the splash.
// Bars: the header lockup, the mark beside the wordmark (asphalt ink, for the day ground).
import headerLockup from '../ds/header-lockup-asphalt.svg';
import lockup from '../ds/wahala-lockup.svg';
import mark from '../ds/wahala-mark.svg';
import { S } from '../strings';

export function Logo({ className = 'logo', bar = false }: { className?: string; bar?: boolean }) {
  return (
    <h1 className={className}>
      {bar ? (
        <img src={headerLockup} alt={S.appName} />
      ) : (
        <>
          <img className="logo__mark" src={mark} alt="" />
          <img className="logo__lockup" src={lockup} alt={S.appName} />
        </>
      )}
    </h1>
  );
}
